// List of all business types for organization categorization
export const BUSINESS_TYPES = [
  '2nd Hand Shop',
  'Accident Repairs',
  'Accommodation',
  'Accountant, Bookkeeping',
  'Acupuncture',
  'Aged Care',
  'Air Conditioning',
  'Alarms',
  'Allied Health',
  'Alterations',
  'Amusement Centre',
  'Amusement Park',
  'Appliance store',
  'Army-Cadets',
  'Art Classes',
  'Art Gallery',
  'Artist',
  'Audiologist',
  'Author',
  'Baby Shop',
  'Baby-Sitters',
  'Bait & Tackle',
  'Bakeries',
  'Bank',
  'Bathroom Renovators',
  'Batteries',
  'BBQ\'s',
  'Beauty Salon',
  'Before & Afterschool Care',
  'Bike Shop, Hire',
  'Blinds, Awnings',
  'Boarding House',
  'Boat Sales, Hire',
  'Boutique Markets',
  'Bowls Club',
  'Bridal Wear',
  'Builders',
  'Building Supplies',
  'Business Directory',
  'Butcher',
  'Cabinet Maker',
  'Café',
  'Camper Trailers',
  'Camping',
  'Camps',
  'Car Accessories',
  'Car Detailing',
  'Car Wash',
  'Car Yards',
  'Caravans',
  'Caretaker',
  'Carpentry',
  'Carpet Cleaning',
  'Carports, Pergolas',
  'Cash Converters',
  'Celebrant',
  'Charter Hire',
  'Cheerleading',
  'Chemist',
  'Childcare',
  'Childrens Play Centre',
  'Chiropractor',
  'Churches',
  'Cinema',
  'Cleaning',
  'Clothing Store',
  'Clothing, Footwear',
  'Clowns',
  'College',
  'College, High School',
  'Computer Repair',
  'Computer Sales',
  'Community Services',
  'Concretor',
  'Construction',
  'Conveyancers',
  'Cooking School',
  'Corner Store',
  'Costume Hire',
  'Council',
  'Counselling',
  'Craft',
  'Crop Dusting',
  'Curtains',
  'Dance School',
  'Dance Wear',
  'Day Spa',
  'Deli',
  'Dentist',
  'Denture Clinic',
  'Dietician',
  'Disability Services',
  'Dishwasher Repairs',
  'Diving',
  'Dog Groomer',
  'Dog Walking',
  'Drama Tuition',
  'Dress Maker',
  'Dress Shop',
  'Drinking Water',
  'Driving School',
  'Dry Cleaners',
  'Dry Dock',
  'Earthmoving',
  'Educational Resources',
  'Electrical Goods',
  'Electrician',
  'Embroidery',
  'Employment Services',
  'Engineering',
  'Engraver / Key Cutter',
  'Entertainment',
  'Equipment Hire',
  'Family Day Care',
  'Farm Machinery',
  'Farm Mechanics',
  'Farm Supplies',
  'Fast Food',
  'Fencing',
  'Financial Advisor',
  'First Aid',
  'Fishing Charters',
  'Flooring',
  'Florists',
  'Formal Hire',
  'Funeral Service',
  'Furniture',
  'Garden Centre',
  'Gas Company',
  'General Store',
  'Glazier',
  'Go Karting',
  'Golf Club',
  'Golf Clubs',
  'Greengrocers',
  'Grocer',
  'Gymnastics',
  'Gyms',
  'Hairdresser',
  'Handyman',
  'Hardware Store',
  'Headlice Treatment',
  'Health Centre',
  'Health Foods',
  'Health Funds',
  'Healthfood',
  'High Schools',
  'Hire Services',
  'Holiday Let',
  'Holiday Park',
  'Home Maintenance',
  'Home Security',
  'Home wares',
  'Horse float',
  'Horse Riding',
  'Hotel, Motels',
  'House Sitting',
  'Housing Development',
  'IGA',
  'Immunology Clinic',
  'Indoor Play Centre',
  'Instrument Shop',
  'Insulation',
  'Insurance',
  'Interior Design',
  'Internet Cafes',
  'Ironing',
  'Jewellers',
  'Juice Bars',
  'Jumping Castle',
  'Kennels, Cattery',
  'Landscape Supplies',
  'Landscaper',
  'Laundromat',
  'Lawn Maintenance',
  'Lawyers, Solicitors',
  'Lego Playgroup',
  'Library',
  'Life Coaching',
  'Lighting',
  'Locksmiths',
  'Machining',
  'Manufacturing',
  'Marina Hire',
  'Marine Mechanics',
  'Markets',
  'Martial Arts',
  'Massage Therapy',
  'Maternity Wear',
  'Mattress & Beds',
  'McDonalds',
  'Mechanic',
  'Medical Centre',
  'Mini Skips',
  'Mobile Vet',
  'Mortgage Broker',
  'Motorbikes',
  'Music Tuition',
  'Nail Technician',
  'Natural Food',
  'Naturopath',
  'Newsagency',
  'Nursery',
  'Nutritionist',
  'Occupational Therapist',
  'Office Supplies',
  'Online Store',
  'Optometrists',
  'Orthodontist',
  'Outdoor Furniture',
  'Paint Stores',
  'Paintball',
  'Painter',
  'Painting Services',
  'Panel Beater',
  'Parenting Program',
  'Party Hire',
  'Pathology',
  'PCYC',
  'Performing Arts',
  'Personal Trainers',
  'Pest Control',
  'Pet Grooming',
  'Pet Sitting',
  'Pet Supplies',
  'Petrol Station',
  'Photography',
  'Physiotherapist',
  'Picture Framers',
  'Pilates',
  'Pizza',
  'Plastics',
  'Plumber',
  'Podiatry',
  'Political - Federal',
  'Political - Local',
  'Political - State',
  'Pool Maintenance',
  'Pool Supplies',
  'Post Office',
  'Preschools',
  'Printer Supplies',
  'Produce',
  'Psychology',
  'Publishing',
  'Pump Services',
  'Quarry',
  'Radio',
  'Real Estate Agents',
  'Removalist',
  'Rental Cars',
  'Respite Care',
  'Restaurants',
  'Resumes',
  'Riding School',
  'Rock Climbing',
  'Roller, Ice Skating',
  'RSL',
  'Rubbish Removal',
  'Rural Supplies',
  'Rust proofing',
  'Saddler',
  'School',
  'School P&C',
  'Scouts',
  'Security',
  'Service Station',
  'Sheds',
  'Shoe Shop',
  'Shopping Centres',
  'Singing Teacher',
  'Skirmish',
  'Smash Repairs',
  'Snake Removal',
  'Solar',
  'Specialist Music Teacher',
  'Speech Pathologist',
  'Sporting Club',
  'Sports Coach',
  'Sports Stores',
  'Spray Tanning',
  'Stockyard',
  'Storage',
  'Subway',
  'Supermarket',
  'Surf Club',
  'Surf Schools',
  'Surf Shops',
  'Suspension',
  'Swim Schools',
  'Takeaway',
  'Talent Agency',
  'Tank cleaning',
  'Technology',
  'Telecommunications',
  'Ten Pin Bowling',
  'Tennis Coaching',
  'Therapist',
  'Towing',
  'Toy Store',
  'Training Courses',
  'Transport',
  'Travel Agents',
  'Tree Lopping',
  'Trophy Shop',
  'Tuition',
  'Tyres',
  'Uni, TAFE',
  'Vet',
  'Video Shop',
  'Virtual Assistant',
  'Waste Removals',
  'Water Boring',
  'Water Carting',
  'Website Design',
  'Wedding Services',
  'Window Tint',
  'Windscreens',
  'Work Uniforms',
  'Yoga',
  'Zoo'
];

export default BUSINESS_TYPES;

